/* eslint spaced-comment: 0 */
import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import config from '@/config.js'
import utils from '@/utils/utils.js'

import Signup from '@/pages/Signup.vue'
import Login from '@/pages/Login.vue'
import Activate from '@/pages/Activate.vue'
import ResetPassword from '@/pages/ResetPassword.vue'
import Dashboard from '@/pages/Dashboard.vue'
import Page404 from '@/pages/Page404.vue'

// Import Dashboard views
import Home from '@/components/Home.vue'
// 一時的に開発用にwatersystem単体画面を用意
import WaterSystem from '@/components/WaterSystem.vue'
import WaterSystemList from '@/components/WaterSystemList.vue'
import Plugins from '@/components/SettingsPlugins.vue'
import Account from '@/components/Account.vue'
import CustomerList from '@/components/CustomerList.vue'
import AccountUserInvite from '@/components/AccountUserInvite.vue'
import AccountOrganizationsUser from '@/components/AccountOrganizationsUser.vue'
import AccountOrganizations from '@/components/AccountOrganizations.vue'
import AccountOrganizationsDetail from '@/components/AccountOrganizationsDetail.vue'
import AccountOrganizationPcList from '@/components/AccountOrganizationPcList.vue'
import Settings from '@/components/Settings.vue'
import Display from '@/components/SettingsDisplay.vue'
import Profile from '@/components/Profile.vue'
import UsageReport from '@/components/UsageReport.vue'
import Notifications from '@/components/Notifications.vue'
import NotificationsMail from '@/components/NotificationsMail.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/signup',
      name: 'Signup',
      component: Signup,
      meta: {
        title: 'Signup',
        requiresAuth: false,
        requiredRoles: []
      }
    }, {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Login',
        requiresAuth: false,
        requiredRoles: []
      }
    }, {
      path: '/activate',
      name: 'Activate',
      component: Activate,
      meta: {
        title: 'Activate your account',
        requiresAuth: false,
        requiredRoles: []
      }
    }, {
      path: '/reset_password',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {
        title: 'Reset your password',
        requiresAuth: false,
        requiredRoles: []
      }
    }, {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      children: [
        {
          path: 'home',
          name: 'Home',
          component: Home,
          alias: '',
          meta: {
            title: 'Home',
            requiresAuth: true,
            requiredRoles: []
          }
        }, {
          path: '/watersystem/:id',
          name: 'WaterSystem',
          component: WaterSystem,
          meta: {
            title: 'WaterSystem',
            requiresAuth: true,
            requiredRoles: [config.role.Root]
          }
        }, {
          path: 'watersystem_list',
          name: 'WaterSystemList',
          component: WaterSystemList,
          meta: {
            title: 'WaterSystemList',
            requiresAuth: true,
            requiredRoles: []
          }
        }, {
          path: 'watersystem_list/:id',
          name: 'WaterSystemListId',
          component: WaterSystemList,
          meta: {
            title: 'WaterSystemList',
            requiresAuth: true,
            requiredRoles: []
          }
        }, {
          path: 'customer_list',
          name: 'CustomerList',
          component: CustomerList,
          meta: {
            title: 'CustomerList',
            requiresAuth: true,
            requiredRoles: []
          }
        }, {
          path: 'settings',
          name: 'Settings',
          component: Settings,
          meta: {
            title: 'Settings',
            requiresAuth: true,
            requiredRoles: []
          },
          children: [
            {
              path: 'display',
              name: 'display',
              component: Display,
              meta: {
                title: 'Display Setting',
                requiresAuth: true,
                requiredRoles: []
              }
            },
            {
              path: 'account',
              name: 'Account',
              component: Account,
              alias: '',
              meta: {
                title: '',
                requiresAuth: true,
                requiredRoles: []
              },
              children: [
                {
                  path: 'user_invite',
                  name: 'UserInvite',
                  component: AccountUserInvite,
                  meta: {
                    title: 'User Invite',
                    requiresAuth: true,
                    requiredRoles: []
                  }
                },
                {
                  path: 'pc_list',
                  name: 'AccountOrganizationPcList',
                  component: AccountOrganizationPcList,
                  meta: {
                    title: 'P/C List',
                    requiresAuth: true,
                    requiredRoles: [config.role.Root]
                  }
                },
                {
                  path: 'organizations',
                  name: 'Organizations',
                  component: AccountOrganizations,
                  alias: '',
                  meta: {
                    title: 'Organization List',
                    requiresAuth: true,
                    requiredRoles: []
                  },
                  children: [
                    {
                      path: 'organizations_detail',
                      name: 'AccountOrganizationsDetail',
                      component: AccountOrganizationsDetail,
                      meta: {
                        title: 'Organization Detail',
                        requiresAuth: true,
                        requiredRoles: []
                      }
                    },
                    {
                      path: 'user_list',
                      name: 'AccountOrganizationsUser',
                      component: AccountOrganizationsUser,
                      meta: {
                        title: 'User List',
                        requiresAuth: true,
                        requiredRoles: []
                      }
                    }
                  ]
                } // organization list
              ]
            }, // account
            {
              path: 'plugins',
              name: 'Plugins',
              component: Plugins,
              meta: {
                title: 'Plugins',
                requiresAuth: true,
                requiredRoles: []
              }
            },
            {
              path: 'notifications',
              name: 'Notifications',
              component: Notifications,
              alias: '',
              meta: {
                title: 'Notifications',
                requiresAuth: true,
                requiredRoles: []
              },
              children: [
                {
                  path: 'notifications_mail',
                  name: 'NotificationsMail',
                  component: NotificationsMail,
                  meta: {
                    title: 'Notification Mail',
                    requiresAuth: true,
                    requiredRoles: []
                  }
                }
              ]
            }
          ]
        }, {
          path: 'profile',
          name: 'Profile',
          component: Profile,
          meta: {
            title: 'Profile',
            requiresAuth: true,
            requiredRoles: []
          }
        }, {
          path: 'usage_report',
          name: 'Usage Report',
          component: UsageReport,
          meta: {
            title: 'Usage Report',
            requiresAuth: true,
            requiredRoles: []
          }
        }
      ]
    }, {
       // not found handler
      path: '*',
      name: 'Page404',
      component: Page404,
      meta: {
        requiresAuth: false,
        requiredRoles: []
      }
    }
  ],
  mode: 'history',
  base: '/dashboard/',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  // タイトル設定
  let domainConfig = utils.getDomainConfig()
  let title = domainConfig.title
  document.title = to.meta.title + title

  // 認証が必要なページかどうか
  if (to.meta.requiresAuth) {
    // ログイン済みかどうか
    if (store.getters.token === null) {
      console.log('Not authenticated')
      store.dispatch('logout')
      .then(() => {
        store.commit('SET_MESSAGE', {
          title: '',
          message: 'Please login',
          level: 'error'
        })
        store.commit('SET_LOGOUTPAGE', to.path)
        next({
          path: '/login'
        })
      })
    // 必要な role があるか
    } else if (!store.getters.userHasThoseRoles(to.meta.requiredRoles)) {
      console.log('do not have permission')
      // ログアウト処理
      store.dispatch('logout')
      .then(() => {
        store.commit('SET_MESSAGE', {
          title: '',
          message: 'Access Denied',
          level: 'error'
        })
        next({
          path: '/login'
        })
      }).catch(err => {
        console.log(err)
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/router.js